import React from 'react';
import cc from 'classcat';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = "@keyframes react-spinner_1-2-0_spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.react-spinner_1-2-0_co-spinner {\n  box-sizing: border-box;\n}\n.react-spinner_1-2-0_co-spinner::before {\n  box-sizing: border-box;\n  content: \"\";\n  display: inline-block;\n  width: var(--spinner-size, 20px);\n  height: var(--spinner-size, 20px);\n  border-radius: var(--border-radius-circular, 50%);\n  border-width: var(--border-width-thin, 2px);\n  border-style: solid;\n  animation: react-spinner_1-2-0_spin 0.5s linear infinite;\n}\n\n.react-spinner_1-2-0_co-spinner.react-spinner_1-2-0_co-spinner--theme::before {\n  border-color: var(--primary-300, #e8eaeb);\n  border-top-color: var(--primary-600, #6f767d);\n}\n.react-spinner_1-2-0_co-spinner.react-spinner_1-2-0_co-spinner--mono-dark::before {\n  border-color: var(--basic-300, #e8eaeb);\n  border-top-color: var(--basic-700, #475059);\n}\n.react-spinner_1-2-0_co-spinner.react-spinner_1-2-0_co-spinner--mono-light::before {\n  border-color: var(--basic-300, #e8eaeb);\n  border-top-color: var(--basic-000, #ffffff);\n}\n\n.react-spinner_1-2-0_co-spinner.react-spinner_1-2-0_co-spinner--micro {\n  --spinner-size: 16px;\n}\n.react-spinner_1-2-0_co-spinner.react-spinner_1-2-0_co-spinner--tiny, .react-spinner_1-2-0_co-spinner {\n  --spinner-size: 20px;\n}\n.react-spinner_1-2-0_co-spinner.react-spinner_1-2-0_co-spinner--small {\n  --spinner-size: 24px;\n}\n.react-spinner_1-2-0_co-spinner.react-spinner_1-2-0_co-spinner--medium {\n  --spinner-size: 32px;\n}\n.react-spinner_1-2-0_co-spinner.react-spinner_1-2-0_co-spinner--large {\n  --spinner-size: 48px;\n}\n.react-spinner_1-2-0_co-spinner.react-spinner_1-2-0_co-spinner--xlarge {\n  --spinner-size: 64px;\n}";
var styles = {
  "co-spinner": "react-spinner_1-2-0_co-spinner",
  "spin": "react-spinner_1-2-0_spin",
  "co-spinner--theme": "react-spinner_1-2-0_co-spinner--theme",
  "co-spinner--mono-dark": "react-spinner_1-2-0_co-spinner--mono-dark",
  "co-spinner--mono-light": "react-spinner_1-2-0_co-spinner--mono-light",
  "co-spinner--micro": "react-spinner_1-2-0_co-spinner--micro",
  "co-spinner--tiny": "react-spinner_1-2-0_co-spinner--tiny",
  "co-spinner--small": "react-spinner_1-2-0_co-spinner--small",
  "co-spinner--medium": "react-spinner_1-2-0_co-spinner--medium",
  "co-spinner--large": "react-spinner_1-2-0_co-spinner--large",
  "co-spinner--xlarge": "react-spinner_1-2-0_co-spinner--xlarge"
};
styleInject(css);

const classModifiers = {
  theme: "co-spinner--theme",
  "mono-dark": "co-spinner--mono-dark",
  "mono-light": "co-spinner--mono-light",
  micro: "co-spinner--micro",
  tiny: "co-spinner--tiny",
  small: "co-spinner--small",
  medium: "co-spinner--medium",
  large: "co-spinner--large",
  xlarge: "co-spinner--xlarge"
};

const Spinner = ({
  className = "",
  color = "theme",
  forwardedRef,
  size = "tiny",
  ...props
}) => {
  const classStyles = cc([styles["co-spinner"], styles[classModifiers[size]], styles[classModifiers[color]], className]);
  return /*#__PURE__*/React.createElement("i", _extends({
    className: classStyles,
    ref: forwardedRef
  }, props, {
    "data-co-name": "Spinner",
    "data-co-version": "1.2.0",
    "data-co-project": "cobalt"
  }));
};

export default Spinner;
